import { useContext, useEffect, useState } from 'react'
import { ReactComponent as Back } from 'assets/transport/drawer/back.svg'
import Drawer from 'react-modern-drawer'
import 'react-modern-drawer/dist/index.css'
import { GlobalContext } from 'App'
import { jsonAxios } from 'components/axios'
import { IInquiryDetail } from 'types/inquiry'

interface IInquiryDrawer {
    isOpen: boolean
    toggleDrawer: () => void
    id?: number
    init: () => void
}

const InquiryDrawer = ({ isOpen, toggleDrawer, id, init }: IInquiryDrawer) => {
    const { isTablet } = useContext(GlobalContext);
    const [data, setData] = useState<IInquiryDetail>({} as IInquiryDetail)

    useEffect(() => {
        if (isOpen && id) {
            jsonAxios.get(`inquiry/${id}`).then(res => {
                console.log(res.data)
                if (res.data.code === 200) {
                    setData(res.data.data)
                }
            })
        }
    }, [isOpen, id])


    return (
        <Drawer
            open={isOpen}
            onClose={() => {
                toggleDrawer();
                init();
            }}
            direction='left'
            lockBackgroundScroll
            size={isTablet ? '100%' : `750px`}
        >
            <div className='flex flex-col gap-6 p-10 tablet:p-4 h-full overflow-y-auto select-text'>
                <div className='flex justify-between items-center'>
                    <p className='font-semibold text-2xl'>1:1 문의</p>
                    <Back onClick={toggleDrawer} />
                </div>

                <div className='flex flex-col px-6 py-3 border border-[#D7D8E6] rounded'>
                    <div className='font-semibold'>{data.title}</div>

                </div>

                <div className='flex-[1] px-6 py-3 border border-[#D7D8E6] rounded'>
                    <div className='flex items-center gap-4'>
                        <p className='font-semibold'>문의 내용</p>
                        <p className='text-[#9D9EB7] text-xs'>{data.createAt}</p>
                    </div>
                    {data.content}
                </div>

                <div className='flex-[1] px-6 py-3 border border-[#D7D8E6] rounded'>
                    <div className='flex items-center gap-4'>
                        <p className='font-semibold'>답변 내용</p>
                        {
                            data.answer &&
                            <p className='text-[#9D9EB7] text-xs'>{data.updateAt}</p>
                        }
                    </div>
                    {
                        data.answer ?
                            <div>
                                {data.answer}
                            </div> :
                            <>답변이 없습니다.</>
                    }
                </div>
            </div>
        </Drawer>
    )
}

export default InquiryDrawer;